import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { Typography } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { EnumEnrollmentMode } from 'widgets/ContactEnrollment/store/types'
import { BroadcastContactsStore } from 'pages/broadcasts/ui/BroadcastView/ui/ContactsContent'
import { UiContactsTrigger } from 'pages/broadcasts/ui/BroadcastView/ui/ContactsContent/ui/UiContactsTrigger'
import { useBroadcastDetailModalContext } from 'pages/broadcasts/ui/BroadcastActions/ui/BroadcastDetailModal/context/context'
import styles from '../styles.module.scss'

export const ContactsContent = observer(() => {
  const broadcast = useBroadcastDetailModalContext()
  const entities = useEntitiesContext()
  const [broadcastContactsStore] = useState(() => new BroadcastContactsStore(entities))

  const handleClick = () => {
    void broadcastContactsStore.editEnrollment()
  }

  useEffect(() => {
    broadcastContactsStore.loadFilters()
    void broadcastContactsStore.init(broadcast.response)
    broadcastContactsStore.enrollmentStore.setMode(EnumEnrollmentMode.ViewOnly)
  }, [])

  return (
    <div className={styles.grid}>
      <Typography ariaLabel={'Send'} variant={'text-input-field'} className={styles.label}>
        Contacts
      </Typography>
      <UiContactsTrigger
        total={broadcastContactsStore.total}
        skipped={broadcastContactsStore.skipped}
        invalidBreakdown={broadcastContactsStore.invalidBreakdown}
        error={''}
        wrapPlaceholderClassName={styles.wrapPlaceholderClassName}
        onClick={handleClick}
      />
    </div>
  )
})
